import { Navigate, Routes, Route } from "react-router-dom";
import AuthConfirmPage from "./pages/authConfirm";
import LoginPage from "./pages/login";
import ExtLoginPage from "./pages/extLogin";
import ProtectedProviderRoutes from "./routes/ProtectedProviderRoutes";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import PATHS from "./constants/paths";
import ChangePasswordPage from "./pages/changePass";
import ForgottenPasswordPage from "./pages/forgottenPass";
// import HomePage from "./pages/home";
import HomePage from "./pages/homeNew";
import FormFormPage from "./pages/form/form";
import FormListPage from "./pages/form/list";
import CourseListPage from "./pages/course/list/index";
import CourseFormPage from "./pages/course/form/index";
import MeetingListPage from "./pages/meeting/list/index";
import MeetingFormPage from "./pages/meeting/formNew/index";
// import SessionListPage from "./pages/session/list/index";
import SessionListPage from "./pages/session/listNew/index";
import SessionFormPage from "./pages/session/form/index";
// import AttendanceListPage from "./pages/attendance/list/index";
import AttendanceListPage from "./pages/attendance/listNew/index";

import UserFormPage from "./pages/createUser/index";
import SettingsListPage from "./pages/settings/index";
import CentersListPage from "./pages/center/index";

function App() {
  return (
    <Routes>
      {/* <Route path="/logout" element={<Logout />} /> */}
      <Route path="/user" element={<ProtectedProviderRoutes />}>
        <Route path={PATHS.HOME} exact element={<HomePage />} />
        <Route
          path={PATHS.CHNAGE_PASSWORD}
          exact
          element={<ChangePasswordPage />}
        />
      </Route>

      <Route path="/adm" element={<ProtectedRoutes />}>
        <Route path={PATHS.FORM_LIST} exact element={<FormListPage />} />

        <Route exact path={PATHS.CREATE_FORM} element={<FormFormPage />} />
        <Route exact path={PATHS.UPDATE_FORM} element={<FormFormPage />} />
        <Route path={PATHS.LIST_COURSE} exact element={<CourseListPage />} />
        <Route path={PATHS.CREATE_COURSE} exact element={<CourseFormPage />} />
        <Route path={PATHS.UPDATE_COURSE} exact element={<CourseFormPage />} />

        <Route path={PATHS.LIST_MEETING} exact element={<MeetingListPage />} />
        <Route
          path={PATHS.CREATE_MEETING}
          exact
          element={<MeetingFormPage />}
        />
        <Route
          path={PATHS.UPDATE_MEETING}
          exact
          edit
          element={<MeetingFormPage />}
        />

        <Route path={PATHS.LIST_SESSION} exact element={<SessionListPage />} />
        <Route
          path={PATHS.CREATE_SESSION}
          exact
          element={<SessionFormPage />}
        />
        <Route
          path={PATHS.CREATE_SESSION_FROM_MEETING}
          exact
          element={<SessionFormPage />}
        />
        <Route
          path={PATHS.UPDATE_SESSION}
          exact
          element={<SessionFormPage />}
        />

        <Route
          path={PATHS.LIST_ATTENDANCE_FROM_SESSION}
          exact
          element={<AttendanceListPage />}
        />
        <Route path={PATHS.NEW_USER} exact element={<UserFormPage />} />

        <Route path={PATHS.SETTINGS} exact element={<SettingsListPage />} />

        <Route path={PATHS.LIST_CENTERS} exact element={<CentersListPage />} />
      </Route>

      <Route
        path={PATHS.EXTERNAL_CONFIRM_LOGIN}
        exact
        element={<AuthConfirmPage />}
      />
      {/* <Route path="/ext/login" exact element={<ExtLoginPage />} /> */}
      <Route path="/login" exact element={<LoginPage />} />
      <Route path="/" element={<Navigate to={"/login"} />} />
      <Route
        path={PATHS.FIRST_CHANGE_PASSWORD}
        exact
        element={<ChangePasswordPage first />}
      />
      <Route
        path={PATHS.FORGOTTEN_PASSWORD}
        exact
        element={<ForgottenPasswordPage />}
      />
    </Routes>
  );
}

export default App;
